import Vue from 'vue';
import { InstanceType } from '../../../enums/InstanceType';
import { getBoIdMapping } from '../../../helpers/boIdMapping';

export async function apartmentsLocationsLocationData(context: Vue) {
	const [locations, locationStats] = await Promise.all([
		context.$locationService.fetchLocations(),
		context.$locationService.fetchLocationStats({
			includeLayoutStats: true
		})
	]);

	await context.$store.fetchTexts(context.$store.page.url, locations.map(l =>
		getBoIdMapping(InstanceType.ApartmentLocation, l)
	));

	return {
		locations,
		locationStats
	};
}
